import React from "react";
import GameButtonWithText from "../GameButtonWithText";
import {LOCO_HEADER_COLOR} from "../GameStyleUI";
import {ELECTRO_TYPE, LOCO_TYPE} from "../../../constants/Constants";
import {GetLocoCost} from "../../../gameplay/model/Balance";
import CardWithCost from "../GeneralCards/CardWithCost";
import steamPic from "../../../images/gameplay_ui/illustrations/steam_pic.png";
import steamIcon from "../../../images/gameplay_ui/icons/heat icon.svg";
import electroPic from "../../../images/gameplay_ui/illustrations/electro_pic.png";
import electroIcon from "../../../images/gameplay_ui/icons/electro icon.svg";
import agent from "../../../agent";
import GameData from "../../../gameplay/model/GameData";
import UtilsFunctions from "../../../utils/UtilsFunctions";

class BuyLocoPopup extends React.Component{
    constructor() {
        super();

        let economyIndex = UtilsFunctions.getRoleNameIndex("Зам. по экономике и финансам");
        this.hasRole = UtilsFunctions.playerHasRole(economyIndex);
    }

    checkRoleCanBuy() {
        return this.hasRole ? "" : "Покупать локомотивы может только Зам. по экономике и финансам";
    }

    buyElectro(){
        let checkRes = this.checkRoleCanBuy();
        if (checkRes.length > 0) {
            alert(checkRes);
            return;
        }

        if (GameData.CurrentGame.cash < GetLocoCost(LOCO_TYPE)){
            alert("Недостаточно средств")
            return;
        }
        agent.GamePlay.buyLoco(this.props.teamID, {locoType: ELECTRO_TYPE, stationId: this.props.stationId}, () =>{

        });
    }
    buyLoco(){
        let checkRes = this.checkRoleCanBuy();
        if (checkRes.length > 0) {
            alert(checkRes);
            return;
        }

        if(GameData.CurrentGame.cash < GetLocoCost(LOCO_TYPE)){
            alert("Недостаточно средств")
            return;
        }
        agent.GamePlay.buyLoco(this.props.teamID, {locoType: LOCO_TYPE, stationId: this.props.stationId}, () =>{

        });
    }
    render() {
        let bgStyle = {
            zIndex: "10",
            display: "flex",
            justifyContent: "space-between",
            position: "relative",
            width: "241px",
            height:"218px",
            padding: "5px",
            borderRadius: "3px",
            background: "#F2F2F2"
        }
        let locoCard = [];
        let colors = LOCO_HEADER_COLOR[LOCO_TYPE];
        let cost = GetLocoCost(LOCO_TYPE);
        locoCard.push(<CardWithCost width={118} height={143} image={steamPic} cost={cost} icon={steamIcon} colors={colors} title={"Тепловоз"} />);
        locoCard.push(<GameButtonWithText
            width={118}
            height={40}
            colorStart={"#8CED00"}
            colorEnd={"#66AE04"}
            disabled={!this.hasRole}
            title={"КУПИТЬ"}
            onClick={this.buyLoco.bind(this)}/>);

        let electroCard = [];
        colors = LOCO_HEADER_COLOR[ELECTRO_TYPE];
        cost = GetLocoCost(ELECTRO_TYPE);
        electroCard.push(<CardWithCost width={118} height={143} image={electroPic} cost={cost} icon={electroIcon} colors={colors} title={"Электровоз"}  />)
        electroCard.push(<GameButtonWithText
            width={118}
            height={40}
            colorStart={"#8CED00"}
            colorEnd={"#66AE04"}
            title={"КУПИТЬ"}
            disabled={!this.hasRole}
            onClick={this.buyElectro.bind(this)}
        />);
        let posStyle = this.props.isRight ? {left: "10px"} : {right: "10px"};
        return <div style={{...bgStyle,...posStyle}}>
            <div>
                {locoCard}
            </div>
            <div>
                {electroCard}
            </div>
        </div>
    }
}
export default BuyLocoPopup;
